import { MobileConnectOnDesktop } from './MobileConnectOnDesktop';
import { MobileDomainTaken } from './MobileDomainTaken';
import { MobileExternalViewerPointingDomain } from './MobileExternalViewerPointingDomain';
import { MobileExternalViewerSubdomainNotAllowed } from './MobileExternalViewerSubdomainNotAllowed';
import { MobileNotSupportedTld } from './MobileNotSupportedTld';
import { MobilePrimaryDomainNotRegistered } from './MobilePrimaryDomainNotRegistered';
import { MobilePrimaryDomainNotRegisteredNoConnect } from './MobilePrimaryDomainNotRegisteredNoConnect';
import { MobilePurchaseRootRequired } from './MobilePurchaseRootRequired';
import { MobileSubdomainRootTaken } from './MobileSubdomainRootTaken';
import { MobileUpgradeRequireConnect } from './MobileUpgradeRequireConnect';
import { FloatingDomain } from './FloatingDomain';
/**
 * Connect-enabled baseline. Private on purpose - consumers go through
 * {@link getLoggedInMobileStatusesConfiguration} so the connect gate can never
 * be bypassed by importing the raw map.
 */
const loggedInMobileStatusesConfiguration = {
  domainTakenInWix: MobileDomainTaken,
  subdomainTakenInWix: MobileSubdomainRootTaken,
  rootDomainIsConnectedByPointing: MobileSubdomainRootTaken,
  subdomainRootIsNotConnected: MobilePrimaryDomainNotRegistered,
  purchaseRootDomainIsRequired: MobilePurchaseRootRequired,
  upgradeRequirePurchaseSubdomain: MobilePurchaseRootRequired,
  upgradeRequireConnect: MobileUpgradeRequireConnect,
  notSupportedTld: MobileNotSupportedTld,
  externalViewerConnectSubdomainNotAllowed: MobileExternalViewerSubdomainNotAllowed,
  externalViewerPurchaseSubdomainNotAllowed: MobileExternalViewerSubdomainNotAllowed,
  externalViewerPointingDomain: MobileExternalViewerPointingDomain,
  floatingDomain: FloatingDomain
};

/**
 * Every status whose card offers a connect CTA on this page. When connect is
 * not available on mobile they all collapse to the "connect on desktop" card,
 * except the subdomain one which keeps its own copy.
 */
const connectDisabledOverrides = {
  connect: MobileConnectOnDesktop,
  transfer: MobileConnectOnDesktop,
  domainTakenInWix: MobileConnectOnDesktop,
  subdomainTakenInWix: MobileConnectOnDesktop,
  rootDomainIsConnectedByPointing: MobileConnectOnDesktop,
  upgradeRequireConnect: MobileConnectOnDesktop,
  upgradeRequireAssign: MobileConnectOnDesktop,
  upgradeRequireTransferIn: MobileConnectOnDesktop,
  subdomainRootIsNotConnected: MobilePrimaryDomainNotRegisteredNoConnect
};
export const getLoggedInMobileStatusesConfiguration = _ref => {
  let isConnectEnabled = _ref.isConnectEnabled;
  return isConnectEnabled ? loggedInMobileStatusesConfiguration : {
    ...loggedInMobileStatusesConfiguration,
    ...connectDisabledOverrides
  };
};
//# sourceMappingURL=customConfiguration.js.map